import React from 'react';

/**
 * SEOHead — DEPRECATED in favor of /public/route-meta.js.
 *
 * We used to use react-helmet-async to inject per-route meta tags. But Emergent's
 * production deploy has aggressive SPA fallback, meaning the static HTML for
 * every URL is identical. The fix is /public/route-meta.js, an inline script
 * that runs BEFORE React mounts and rewrites <title>, <meta name="description">,
 * <link rel="canonical">, og:*, twitter:*, and per-route JSON-LD based on
 * window.location.pathname.
 *
 * Helmet kept duplicating tags on top of route-meta.js's output, so we render
 * nothing here. Page components can keep calling <SEOHead /> without breaking.
 *
 * If you need to add metadata for a new route, edit /public/route-meta.js.
 */
const DEFAULT_DOMAIN = 'https://howbusyismyairport.com';
const SITE_NAME = 'How Busy Is My Airport';

export default function SEOHead() {
  return null;
}

// Legacy helpers retained for any code that still imports them.
import { SOCIAL_PROFILES } from '@/config/socialProfiles';

export function buildBreadcrumb(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: it.name,
      item: it.url.startsWith('http') ? it.url : `${DEFAULT_DOMAIN}${it.url}`,
    })),
  };
}

export function buildOrganization() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: DEFAULT_DOMAIN,
    logo: `${DEFAULT_DOMAIN}/logo.png`,
    sameAs: SOCIAL_PROFILES,
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'jamursch@gmail.com',
      contactType: 'customer support',
    },
  };
}

// Injects sameAs (social profiles) into the static Organization JSON-LD in
// index.html at runtime. Google's renderer executes JS, so this links the
// profiles to the brand sitewide from one config file.
export function injectSocialProfiles() {
  if (typeof document === 'undefined' || SOCIAL_PROFILES.length === 0) return;
  document.querySelectorAll('script[type="application/ld+json"]').forEach((s) => {
    try {
      const data = JSON.parse(s.textContent);
      if (data['@type'] === 'Organization' && !data.sameAs) {
        data.sameAs = SOCIAL_PROFILES;
        s.textContent = JSON.stringify(data);
      }
    } catch { /* skip malformed blocks */ }
  });
}

export const SITE = {
  domain: DEFAULT_DOMAIN,
  name: SITE_NAME,
};
